module.exports = __webpack_public_path__ + "img/classic.7eaf681c.png";